import { useEffect, useRef } from 'react';
import classNames from 'classnames';

type Props = {
    title: string;
    hideCloseButton?: boolean;
    openModal?: boolean;
    onClose: () => void;
    children: React.ReactNode;
    className?: string;
    fullscreen?: boolean;
};

export function Modal({
    title,
    hideCloseButton = false,
    openModal = true,
    onClose,
    children,
    className,
    fullscreen,
}: Props) {
    const dialogElement = useRef<HTMLDialogElement>(null);

    useEffect(() => {
        if (dialogElement.current) {
            if (openModal) {
                dialogElement.current.showModal();
            } else {
                dialogElement.current.close();
            }
        }
    }, [openModal]);

    function closeDialog() {
        if (dialogElement.current) {
            dialogElement.current.close();
            onClose();
        }
    }

    return (
        <dialog
            className={classNames(
                'max-w-dialog rounded-md bg-white backdrop:bg-dark-blue/60',
                {
                    'fullscreen md:fullscreen-md': fullscreen,
                },
            )}
            style={{ width: 'calc(100% - 40px)' }}
            onClose={onClose}
            ref={dialogElement}
        >
            <div
                className={classNames(
                    className,
                    'flex flex-col justify-items-start',
                )}
            >
                <header className="horizontal-20">
                    <h2 className="text-display-2">{title}</h2>
                    {hideCloseButton || (
                        <button
                            type="button"
                            onClick={closeDialog}
                            className="flex h-40 w-40 justify-center"
                        >
                            <img
                                src="/images/falck/close-dialog.svg"
                                alt=""
                                width="30"
                                height="30"
                            />
                        </button>
                    )}
                </header>

                {children}
            </div>
        </dialog>
    );
}
